import { connect } from 'react-redux'

import Actions from '../../Actions/Creators'
import SmartClinic from './Component/SmartClinic'

import { destroy } from 'redux-form'

import Phi from '../../Phi/Phi'
import SchoolOverViewComponent from '../DashboardContainer/Component/SchoolOverViewComponent'


const mapStateToProps = (state, ownProps) => ({
    organizationId: JSON.parse(Phi.Storage.getItem('organization')) ? JSON.parse(Phi.Storage.getItem('organization'))[0].org_id : null,

    episodeHeader: state.student.episodeHeader,
    episodeList: state.student.episodeList,
    episodeTotal: state.student.episodeTotal,

    studentHeader: state.student.clinicStudentHeader,
    studentList: state.student.clinicStudentList,
    studentTotal: state.student.clinicStudentTotal,

    episodeStats: state.student.episodeStats,

    metaMeds: state.organization.plusMetaMeds,
    metaSymp: state.organization.plusMetaSympt,
    metaTreat: state.organization.plusMetaTreat,
    metaVitals: state.organization.plusMetaVitals,
    
   

})


const mapDispatchToProps = (dispatch) => ({
    fetchEpisodeSearch: (header) => dispatch(Actions.fetchStudentEpisodeSearch(header)),
    fetchStudentSearch: (header) => dispatch(Actions.fetchClinicStudentSearch(header)),
    fetchEpisodeStats: (inOrganizationId) => dispatch(Actions.fetchClinicEpisodeStats(inOrganizationId)),
    
    resetEpisodeSearch: (header) => dispatch(Actions.storeStudentEpisodeSearch({
        episodeList: [],
        episodeTotal: 0,
        episodeHeader: header
    })),

    postStudentEpisode: (studentId, customJson, episodeType) => dispatch(Actions.postStudentEpisodeInfo(studentId, customJson, episodeType)),
    initializeForm: (data) => dispatch(Actions.initializeForm(data)),
    fetchNurseMeta: () => dispatch(Actions.fetchNurseMeta()),
    clearForm: () => dispatch(destroy('customForm'))

    
})

export default connect(mapStateToProps, mapDispatchToProps)(SmartClinic)